import { RestaurantDealCard } from '@/features/restaurants/restaurant-deal-card'
import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { RestaurantDetailSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-section'
import { RestaurantDetailSectionId } from '@/features/restaurants/restaurant-detail/utils/restaurant-detail-helpers'

export function RestaurantDetailDeals() {
    const { restaurant } = useRestaurantDetailContext()

    if (!restaurant?.deals?.length) return null

    return (
        <RestaurantDetailSection
            id={RestaurantDetailSectionId.DEALS}
            title="restaurants.detail.deals.title"
            description="restaurants.detail.deals.description"
        >
            <div className="flex gap-y-4 gap-x-8 md:flex-row flex-col">
                {restaurant.deals?.map((deal) => {
                    return (
                        <RestaurantDealCard
                            key={'restaurant-detail-content' + deal.uuid}
                            deal={deal}
                        />
                    )
                })}
            </div>
        </RestaurantDetailSection>
    )
}
